<template>
  <div class="section">
    <h3 class="mt-4">
      証拠品
      <small class="text-muted">
        <font-awesome-icon icon="plus" @click="openModal()" />
      </small>
    </h3>
    <draggable tag="div" class="row" :list="list" :value="value" @input="emitter">
      <div class="col-3" v-for="e in realValue" :key="e.id">
        <div class="card mb-3 shadow-sm" @dblclick="openModal(e)">
          <div class="card-body">
            <h4 class="card-title">
              {{ e.name }}
              <small class="text-muted">
                <font-awesome-icon icon="edit" @click="openModal(e)" />
              </small>
            </h4>
            <MarkdownView :text="e.text" />
          </div>
        </div>
      </div>
    </draggable>
    <b-modal :id="uid('modal')"
             centered size="xl"
             title="証拠品"
             @shown="modalShown"
             @ok="modalSave">
      <form @submit.stop.prevent="modalSubmit">
        <div class="form-group">
          <label :for="uid('modal-name')">名前</label>
          <input :id="uid('modal-name')"
                 type="text"
                 class="form-control"
                 ref="modalName"
                 v-model="name" />
        </div>
        <div class="form-group">
          <label :for="uid('modal-text')">情報</label>
          <textarea :id="uid('modal-text')"
                    class="form-control"
                    ref="modalText"
                    rows="30"
                    v-model="text"
                    @keypress="modalKeyPress">
          </textarea>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import MarkdownView from '@/components/MarkdownView.vue'

export default {
  name: 'CharacterList',

  components: {
    draggable,
    MarkdownView
  },

  data(){
    return {
      id: '',
      name: '',
      text: ''
    }
  },

  methods: {
    emitter(value){
      this.$emit('input', value)
    },

    uid(prefix){
      return prefix + '-' + this._uid
    },

    openModal(e){
      if(e){
        this.id = e.id
        this.name = e.name
        this.text = e.text
      }else{
        this.id = null
        this.name = ''
        this.text = ''
      }
      this.$bvModal.show(this.uid('modal'))
    },

    modalShown(){
      if(this.id){
        this.$refs.modalText.focus()
      }else{
        this.$refs.modalName.focus()
      }
    },

    modalKeyPress(e){
      if(e.ctrlKey && e.keyCode == 10){ this.modalSubmit() }
    },

    modalSubmit(){
      this.modalSave()
      this.$bvModal.hide(this.uid('modal'))
    },

    modalSave(){
      const value = this.value || this.list
      if(this.id){
        const obj = value.find(e => e.id == this.id)
        obj.name = this.name
        obj.text = this.text
      }else{
        value.push({
          name: this.name,
          text: this.text
        })
      }
      this.emitter(value)
    }
  },

  computed: {
    realValue(){
      return this.value || this.list
    },
  },

  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    list: {
      required: false,
      type: Array,
      default: null
    }
  }
}
</script>

<style scoped>
</style>
